import { stateNameMap } from '@/Modules/Grafer/common/stateMappings';

function generateDynamicLineData(jobs) {
  const now = new Date();
  const cutoffTime = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  const internalStates = Object.keys(stateNameMap);

  const formatHour = (date) =>
    `${String(date.getHours()).padStart(2, '0')}:00`;

  const roundToHour = (date) => {
    const rounded = new Date(date);
    rounded.setMinutes(0, 0, 0);
    return rounded;
  };

  const createEmptyBucket = (date) => {
    const bucket = {
      time: formatHour(date),
      bucketDate: date
    };
    internalStates.forEach(state => {
      bucket[state] = 0;
    });
    return bucket;
  };

  // Build time buckets
  const jobsByTime = new Map();

  jobs.forEach(job => {
    const jobTime = new Date(job.startTime);
    if (jobTime < cutoffTime || jobTime > now) return;

    const roundedHour = roundToHour(jobTime);
    const timeKey = roundedHour.getTime();

    if (!jobsByTime.has(timeKey)) {
      jobsByTime.set(timeKey, createEmptyBucket(roundedHour));
    }

    const bucket = jobsByTime.get(timeKey);
    if (internalStates.includes(job.state)) {
      bucket[job.state]++;
    }
  });

  let lineData = Array.from(jobsByTime.values())
    .sort((a, b) => a.bucketDate - b.bucketDate);

  const startHour = roundToHour(cutoffTime);
  const endHour = roundToHour(now);

  if (lineData.length === 0) {
    lineData = [createEmptyBucket(startHour), createEmptyBucket(endHour)];
  } else {
    if (lineData[0].bucketDate > startHour) {
      lineData.unshift(createEmptyBucket(startHour));
    }
    if (lineData[lineData.length - 1].bucketDate < endHour) {
      lineData.push(createEmptyBucket(endHour));
    }
  }

  const statesWithData = new Set();
  lineData.forEach(bucket => {
    internalStates.forEach(state => {
      if ((bucket[state] || 0) > 0) {
        statesWithData.add(state);
      }
    });
  });

  return lineData.map(bucket => {
    const result = { time: bucket.time };
    statesWithData.forEach(state => {
      result[state] = bucket[state] || 0;
    });
    return result;
  });
}

export function jobTimelineDataProcessor(rawData) {
  const transformed = generateDynamicLineData(rawData)

  const stateKeys = new Set()
  transformed.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'time') stateKeys.add(key)
    })
  })

  const series = Array.from(stateKeys).map(stateKey => ({
    name: stateNameMap[stateKey] || stateKey,
    data: transformed.map(item => item[stateKey] || 0)
  }))

  return {
    series,
    categories: transformed.map(item => item.time)
  }
}
